<template>
  <div>
    <v-container v-if="loading">
      <v-row>
        <v-col v-if="studentSubjects.length < 1 && optionalSubjects.length<1">
          <v-alert
            type="error"
            v-if="$checkPermission('department lock enrollments')"
          >
            Morate zaključati učenike kako biste vidjeli osnovne predmete!
            <v-btn text class="text-none" @click="goToLockDepartment">
              Idi zaključati učenike
            </v-btn>
          </v-alert>
          <v-alert v-else type="error">
            Potrebno je zaključati učenike kako biste vidjeli osnovne predmete!
            Obratite se školskom koordinatoru kako bi zaključao učenike.
          </v-alert>
        </v-col>
      </v-row>
      <v-row v-if="studentSubjects.length >0 || optionalSubjects.length> 0">
        <v-col cols="12">
          <h3>Ocjene</h3>
        </v-col>
        <v-col
          cols="12"
          sm="4"
          v-if="
            $checkPermission('department lock subjects') &&
              !enrolledStudent.locked_subjects
          "
        >
          <v-tooltip bottom :disabled="studentSubjectsLength !== 0">
            <template v-slot:activator="{ on }">
              <div v-on="on" class="d-inline-block">
                <v-btn
                    :disabled="studentSubjectsLength === 0"
                    class="text-none"
                    depressed
                    height="44"
                    color="error"
                    block
                    @click="openLockDialog('lock_subjects', 1)"
                >
                  <v-icon class="mr-2">mdi-lock</v-icon> Zaključaj predmete
                </v-btn>
              </div>
            </template>
            <span>Morate upisati barem jedan predmet</span>
          </v-tooltip>
        </v-col>
        <!-- <v-col v-if="!$checkPermission('department lock subjects') && enrolledStudent.locked_subjects">
                    <v-btn
                        class="text-none"
                        depressed
                        height="44"
                        color="error"
                        block
                        @click="openLockDialog('lock_subjects', 0)"
                    >
                        <v-icon class="mr-2">mdi-lock-open</v-icon> Otključaj predmete
                    </v-btn>
                </v-col> -->
      </v-row>
      <v-row v-if="studentSubjects.length > 0 || optionalSubjects.length > 0">
        <v-col
          v-if="
            $checkPermission('demand create') && enrolledStudent.locked_subjects
          "
          cols="12"
          sm="6"
          md="5"
        >
          <v-btn
            class="send-demand-btn text-none text-wrap"
            depressed
            height="44"
            color="primary"
            block
            text
            @click="openDemandDialog"
          >
            Pošalji zahtjev za otključavanje predmeta
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="studentSubjects.length > 0 || optionalSubjects.length > 0">
        <v-col>
          <v-data-table
            :headers="headers"
            :items="studentSubjects"
            hide-default-footer
            disable-pagination
            class="elevation-0"
            loading-text="Traženje..."
          >
<!--            1. Polugodište ocjene-->
            <template
              v-if="areNumericalGradesSemester"
              v-slot:[`item.pivot.final_grade_semester`]="{ item }"
            >
              <v-form
                :ref="`form_${item.id}`"
                v-model="valid"
                @submit.prevent=""
              >
                <v-autocomplete
                  :ref="
                    `ocjena.${studentSubjects.indexOf(
                      studentSubjects.filter((x) => x.id == item.id)[0]
                    )}`
                  "
                  :items="grades"
                  item-text="text"
                  item-value="value"
                  class="input-ocjena"
                  outlined
                  dense
                  v-model="item.pivot.final_grade_semester"
                  :disabled="
                    enrolledStudent.locked_grades_semester ||
                      !$checkPermission('department_subject conclude grade')
                  "
                  hide-details
                  clearable
                  auto-select-first
                  style="width: 180px"
                  @keyup.enter="focusNext(item)"
                  @change="updateSemesterGrade(item)"
                >
                </v-autocomplete>
              </v-form>
            </template>
            <template
              v-else
              v-slot:[`item.pivot.descriptive_grade_semester`]="{ item }"
            >
              <v-form :ref="`form_${item.id}`" @submit.prevent="" v-model="valid">
                <v-textarea
                  outlined
                  dense
                  v-model="item.pivot.descriptive_grade_semester"
                  :disabled="
                    enrolledStudent.locked_grades_semester ||
                      !$checkPermission('department_subject conclude grade')
                  "
                  auto-grow
                  counter="150"
                  :rules="[
                    (v) => (v || '').length <= 150 || 'Maksimalno 150 znakova',
                  ]"
                  rows="1"
                  @blur="updateSemesterGrade(item)"
                >
                </v-textarea>
<!--                <v-combobox-->
<!--                    :items="descriptiveGrades"-->
<!--                    outlined-->
<!--                    dense-->
<!--                    no-data-text="Kliknite enter da kreirate predložak sa unesenim tekstom"-->
<!--                    v-model="item.pivot.descriptive_grade_semester"-->
<!--                    :disabled="-->
<!--                    enrolledStudent.locked_grades_semester ||-->
<!--                      !$checkPermission('department_subject conclude grade')-->
<!--                  "-->
<!--                    hide-details-->
<!--                    clearable-->
<!--                    @blur="updateSemesterGrade(item)"-->
<!--                >-->
<!--                </v-combobox>-->

              </v-form>
            </template>
            <!--  2. Polugodište ocjene-->
            <template
                v-if="areNumericalGrades"
                v-slot:[`item.pivot.final_grade_second_semester`]="{ item }"
            >
              <v-form
                  :ref="`form_${item.id}`"
                  v-model="valid"
                  @submit.prevent=""
              >
                <v-autocomplete
                    :ref="
                    `2ocjena.${studentSubjects.indexOf(
                      studentSubjects.filter((x) => x.id == item.id)[0]
                    )}`
                  "
                    :items="grades"
                    item-text="text"
                    item-value="value"
                    class="input-ocjena"
                    outlined
                    dense
                    v-model="item.pivot.final_grade_second_semester"
                    :disabled="
                    enrolledStudent.locked_grades ||
                      !$checkPermission('department_subject conclude grade')
                  "
                    hide-details
                    clearable
                    auto-select-first
                    style="width: 180px"
                    @keyup.enter="focusNext(item,2)"
                    @change="updateSemesterGrade(item)"
                >
                </v-autocomplete>
              </v-form>
            </template>
            <template
                v-else
                v-slot:[`item.pivot.descriptive_grade_second_semester`]="{ item }"
            >
              <v-form :ref="`form_${item.id}`" @submit.prevent="" v-model="valid">
                                <v-textarea
                                  outlined
                                  dense
                                  v-model="item.pivot.descriptive_grade_second_semester"
                                  :disabled="
                                    enrolledStudent.locked_grades ||
                                      !$checkPermission('department_subject conclude grade')
                                  "
                                  auto-grow
                                  counter="150"
                                  :rules="[
                                    (v) => (v || '').length <= 150 || 'Maksimalno 150 znakova',
                                  ]"
                                  rows="1"
                                  @blur="updateSemesterGrade(item)"
                                >
                                </v-textarea>
<!--                <v-combobox-->
<!--                    :items="descriptiveGrades"-->
<!--                    outlined-->
<!--                    dense-->
<!--                    no-data-text="Kliknite enter da kreirate predložak sa unesenim tekstom"-->
<!--                    v-model="item.pivot.descriptive_grade_second_semester"-->
<!--                    :disabled="-->
<!--                    enrolledStudent.locked_grades ||-->
<!--                      !$checkPermission('department_subject conclude grade')-->
<!--                  "-->
<!--                    hide-details-->
<!--                    clearable-->
<!--                    @blur="updateSemesterGrade(item)"-->
<!--                >-->
<!--                </v-combobox>-->

              </v-form>
            </template>
            <!--  Kraj ocjene-->
            <template
                v-if="areNumericalGrades"
                v-slot:[`item.pivot.final_grade`]="{ item }"
            >
              <v-form
                  :ref="`form_${item.id}`"
                  v-model="valid"
                  @submit.prevent=""
              >
                <v-autocomplete
                    :ref="
                    `3ocjena.${studentSubjects.indexOf(
                      studentSubjects.filter((x) => x.id == item.id)[0]
                    )}`
                  "
                    :items="grades"
                    item-text="text"
                    item-value="value"
                    class="input-ocjena"
                    outlined
                    dense
                    v-model="item.pivot.final_grade"
                    :disabled="
                    enrolledStudent.locked_grades ||
                      !$checkPermission('department_subject conclude grade')
                  "
                    hide-details
                    auto-select-first
                    clearable
                    style="width: 180px"
                    @keyup.enter="focusNext(item, 3)"
                    @change="updateSemesterGrade(item)"
                >
                </v-autocomplete>
              </v-form>
            </template>
            <template
                v-else
                v-slot:[`item.pivot.descriptive_grade`]="{ item }"
            >
              <v-form :ref="`form_${item.id}`" @submit.prevent="" v-model="valid">
                                <v-textarea
                                  outlined
                                  dense
                                  v-model="item.pivot.descriptive_grade"
                                  :disabled="
                                    enrolledStudent.locked_grades ||
                                      !$checkPermission('department_subject conclude grade')
                                  "
                                  auto-grow
                                  counter="150"
                                  :rules="[
                                    (v) => (v || '').length <= 150 || 'Maksimalno 150 znakova',
                                  ]"
                                  rows="1"
                                  @blur="updateSemesterGrade(item)"
                                >
                                </v-textarea>
<!--                <v-combobox-->
<!--                    :items="descriptiveGrades"-->
<!--                    outlined-->
<!--                    dense-->
<!--                    no-data-text="Kliknite enter da kreirate predložak sa unesenim tekstom"-->
<!--                    v-model="item.pivot.descriptive_grade"-->

<!--                    hide-details-->
<!--                    clearable-->
<!--                    @blur="updateSemesterGrade(item)"-->
<!--                >-->
<!--                </v-combobox>-->

              </v-form>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <!-- delete button for optional subject if exist -->
              <v-btn
              v-if="(item.optional === 1 && !enrolledStudent.locked_subjects) && (currentRole.role_id === 1 || currentRole.role_id === 3)"
                depressed
                width="40"
                min-width="40"
                color="error"
                @click="openDeleteSuperAdmin(item.pivot.id)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-btn
                  v-if="(item.optional === 1 && !enrolledStudent.locked_subjects) && (currentRole.role_id === 5)"
                  depressed
                  width="40"
                  min-width="40"
                  color="error"
                  @click="openDelete(item.id)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>

            </template>

            <template v-slot:no-data>
              <span>
                Za tražene pojmove nema rezultata pretrage.
              </span>
            </template>
          </v-data-table>
        </v-col>

        <v-col
          v-if="
            !enrolledStudent.locked_subjects &&
              $checkPermission('enrollment_subject create')
          "
          cols="12"
          sm="8"
          md="4"
        >
          <v-card outlined class="pa-2">
            <v-card-title class="justify-center">Izborni predmeti</v-card-title>
            <v-container v-if="filteredOptionalSubjects.length > 0">
              <v-row
                v-for="(optional, index) in filteredOptionalSubjects"
                :key="index"
                justify="center"
              >
                <v-col cols="12">
                  <v-list-item class="optional-subject-list flex-column">
                    <v-list-item-content class="d-flex flex-row">
                      <v-list-item-title style="white-space: normal">{{
                        optional.subject.title
                      }}</v-list-item-title>
                      <v-list-item-subtitle
                        >Naziv predmeta</v-list-item-subtitle
                      >
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn
                        depressed
                        color="primary"
                        class="text-none"
                        block
                        @click="openDialog(optional.id)"
                      >
                        Upiši predmet
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    v-if="index < filteredOptionalSubjects.length - 1"
                  ></v-divider>
                </v-col>
              </v-row>
            </v-container>
            <v-card-text v-else class="text-center text--disabled">
              Nema izbornih predmeta
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog" width="500" @click:outside="dialog = false">
      <v-card>
        <v-card-title primary-title>
          Jeste li sigurni?
        </v-card-title>

        <v-card-text style="padding-top: 20px;">
          Jeste li sigurni da želite upisati izborni predmet?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="dialog = false"
            class="text-none"
            depressed
            large
            outlined
            >Odustani</v-btn
          >
          <v-btn
            color="primary"
            class="text-none"
            @click="attachOptionalSubject"
            depressed
            large
            >Upiši</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      width="500"
      @click:outside="deleteDialog = false"
    >
      <v-card>
        <v-card-title primary-title>
          Jeste li sigurni?
        </v-card-title>

        <v-card-text style="padding-top: 20px;">
          Jeste li sigurni da želite ukloniti izborni predmet?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="deleteDialog = false"
            class="text-none"
            depressed
            large
            outlined
            >Odustani</v-btn
          >
          <v-btn
            color="error"
            class="text-none"
            @click="detachOptionalSubject"
            depressed
            large
            >Izbriši</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="deleteDialogSuperAdmin"
        width="500"
        @click:outside="deleteDialogSuperAdmin = false"
    >
      <v-card>
        <v-card-title primary-title>
          Jeste li sigurni?
        </v-card-title>

        <v-card-text style="padding-top: 20px;">
          <v-alert
              type="orange"
              icon="mdi-alert-outline"
              outlined
              border="left">
            Molimo vas da budete izuzetno oprezni prilikom brisanja ovog predmeta. Ovim postupkom, ukoliko postoje, gubite sve informacije vezane uz taj predmet, uključujući unesene sate, izostanke, ocjene, godišnje planove i bilješke.

          </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="deleteDialogSuperAdmin = false"
              class="text-none"
              depressed
              large
              outlined
          >Odustani</v-btn
          >
          <v-btn
              color="error"
              class="text-none"
              @click="secondDeleteDialogSuperAdmin = true"
              depressed
              large
          >Izbriši</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="secondDeleteDialogSuperAdmin"
        width="500"
        @click:outside="secondDeleteDialogSuperAdmin = false"
    >
      <v-card>
        <v-card-title primary-title>
          Opasna radnja!
        </v-card-title>

        <v-card-text style="padding-top: 20px;">
          <v-alert
              type="orange"
              icon="mdi-alert-outline"
              outlined
              border="left">
            Ako ste sigurni da želite nastaviti s brisanjem, molimo vas da potvrdite svoj odabir. U suprotnom, molimo vas da se vratite i provjerite svoje odluke.
          </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="secondDeleteDialogSuperAdmin = false"
              class="text-none"
              depressed
              large
              outlined
          >Odustani</v-btn
          >
          <v-btn
              color="error"
              class="text-none"
              @click="detachOptionalSubjectSuperAdmin"
              depressed
              large
          >Izbriši</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>



    <v-dialog
      v-model="lockDialog"
      width="500"
      @click:outside="lockDialog = false"
    >
      <v-card>
        <v-card-title primary-title>
          Jeste li sigurni?
        </v-card-title>

        <v-card-text class="pt-5">
          Jeste li sigurni da želite potvrditi? <br />
          <span class="font-weight-bold">Upozorenje:</span>
          Kada potvrdite predmete više neće imati mogućnost dodavanja izbornih
          predmeta.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="lockDialog = false"
            class="text-none"
            depressed
            large
            outlined
            >Odustani</v-btn
          >
          <v-btn
            color="error"
            @click="lockDepartment"
            class="text-none"
            depressed
            large
            >Potvrdi</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="demandDialog"
      width="400"
      @click:outside="closeDemandDialog"
    >
      <v-card>
        <v-toolbar color="primary" dark class="elevation-0">
          <v-toolbar-title>Pošalji zahtjev</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn @click.native="closeDemandDialog" dark icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="mt-6">
          <v-row>
            <v-col cols="12">
              <v-textarea
                outlined
                dense
                auto-grow
                v-model="demandReason"
                rows="3"
                label="Razlog"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="closeDemandDialog"
            class="text-none"
            depressed
            large
            outlined
            >Odustani</v-btn
          >
          <v-btn
            color="primary"
            class="text-none"
            @click="sendDemand"
            depressed
            large
            >Potvrdi</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ApiV2 from "@/services/ApiV2";
import { serverBus } from "@/main";

export default {
  props: {
    department: {
      type: Object
    }
  },
  data: function() {
    return {
      studentSubjects: [],
      optionalSubjects: [],
      optionalSubjectId: null,
      studentSubjectsLength: 0,
      deleteDialog: false,
      deleteDialogSuperAdmin: false,
      secondDeleteDialogSuperAdmin: false,
      dialog: false,
      gradeType: false,
      semesterGradeDialog: false,
      subjectTitle: "",
      lockDialog: false,
      demandDialog: false,
      loading: false,
      demandReason: "",
      form: {},
      serverItemsLength: 0,
      dialogText: "",
      valid: true,
      grades: [
        { value: 5, text: "odličan (5)" },
        { value: 4, text: "vrlo dobar (4)" },
        { value: 3, text: "dobar (3)" },
        { value: 2, text: "dovoljan (2)" },
        { value: 1, text: "nedovoljan (1)" },
        { value: 0, text: "neocijenjen" },
        { value: -1, text: "obavljena" },
        {value: -2, text: "/"},
      ],
      descriptiveGrades: [
      ],
    };
  },

  created() {
    this.getStudentSubjects();
    if (!this.enrolledStudent.locked_subjects) {
      this.getDepartmentSubjects();
    }
  },

  computed: {
    currentRole() {
      return this.$store.getters.getCurrentRole;
    },
    areNumericalGrades(){
      return this.department?.are_numerical_grades
    },
    areNumericalGradesSemester(){
      return this.department?.are_numerical_grades_semester
    },
    filteredOptionalSubjects() {
      if (this.studentSubjects.length>0) {
        let ids = this.studentSubjects.map((subject) => subject.id);

        return this.optionalSubjects.filter(
          (item) => ids.indexOf(item.id) === -1
        );
      } else {
        return this.optionalSubjects;
      }
    },
    headers() {
      let headers = [
        { text: "Predmet", value: "subject.title", sortable: false },
        {
          text: "Opisna ocjena 1. polugodište",
          value: "pivot.descriptive_grade_semester",
          sortable: false,
        },
        {
          text: "Opisna ocjena 2. polugodište",
          value: "pivot.descriptive_grade_second_semester",
          sortable: false,
        },
        {
          text: "Opisna ocjena kraj godine",
          value: "pivot.descriptive_grade",
          sortable: false,
        },
        {
          text: "Zaključna ocjena 1. polugodište",
          value: "pivot.final_grade_semester",
          sortable: false,
        },
        {
          text: "Zaključna ocjena 2. polugodište",
          value: "pivot.final_grade_second_semester",
          sortable: false,
        },
        {
          text: "Zaključna ocjena kraj godine",
          value: "pivot.final_grade",
          sortable: false,
        },
        { text: "Akcije", value: "actions", sortable: false },
      ];

      /* ukloni akcije ako su predmeti zaključane ili korisnik nema dozvole za akcije */
      if (
        this.enrolledStudent.locked_subjects ||
        !this.$checkPermission("department_subject conclude grade")
      ) {
        headers.pop();
      }

      if (this.areNumericalGrades) {
        // ukloni opisne ocjene
        headers.splice(2,1)
        headers.splice(2,1)
      } else {
        // ukloni brojčane ocjene
        headers.splice(5,1)
        headers.splice(5,1)
      }
      if(this.areNumericalGradesSemester){
        headers.splice(1,1)
      }else{
        if(this.areNumericalGrades){
          headers.splice(2,1)
        }else{
          headers.splice(4,1)
        }
      }

      return headers;
    },

    enrolledStudent() {
      return this.$store.getters.getEnrolledStudent;
    },

    currentSchool() {
      return this.$store.getters.getSchool;
    },

    checkFinalSemesterGrades() {
      /* provjerava jesu li sve ocjene zaključene na polugodištu */
      return this.studentSubjects.some(
        (subject) => subject.pivot.final_grade_semester === null
      );
    },
  },

  methods: {
    focusNext(item, type=1) {
      if (
        this.studentSubjects.indexOf(
          this.studentSubjects.filter((x) => x.id == item.id)[0]
        ) +
          1 <
        this.studentSubjects.length
      ) {
        if (type===1){
          this.$refs[
              `ocjena.${this.studentSubjects.indexOf(
                  this.studentSubjects.filter((x) => x.id == item.id)[0]
              ) + 1}`
              ].$refs.input.focus();
        }
        if (type===2){
          this.$refs[
              `2ocjena.${this.studentSubjects.indexOf(
                  this.studentSubjects.filter((x) => x.id == item.id)[0]
              ) + 1}`
              ].$refs.input.focus();
        }
        if (type===3){
          this.$refs[
              `3ocjena.${this.studentSubjects.indexOf(
                  this.studentSubjects.filter((x) => x.id == item.id)[0]
              ) + 1}`
              ].$refs.input.focus();
        }

      }
    },
    goToLockDepartment() {
      this.$router.push({
        path: `/admin/odjeljenje/pregled/${this.$route.params.odjeljenje_id}`,
        query: { tab: 1 },
      });
    },

    showAddForm: function() {
      this.$navigate(
        `/admin/ucenik/pregled/${this.$route.params.ucenik_id}/add`
      );
    },

    openDialog(optionalId) {
      this.dialog = true;
      this.optionalSubjectId = optionalId;
    },

    openDelete(id) {
      this.deleteDialog = true;
      this.optionalSubjectId = id;
    },
    openDeleteSuperAdmin(id) {
      this.deleteDialogSuperAdmin = true;
      this.optionalSubjectId = id;
    },

    openLockDialog() {
      this.lockDialog = true;
    },

    openDemandDialog() {
      this.demandDialog = true;
      this.demandReason = "";
    },

    closeDemandDialog() {
      this.demandDialog = false;
    },

    getStudentSubjects() {
      ApiV2.get(
        `department_enrollment/${this.enrolledStudent.id}/departmentSubjects`,
        {
          params: {
            with: ["subject"],
            perPage: -1,
          },
        }
      )
        .then((response) => {
          this.studentSubjects = response.data.data;
          if (this.studentSubjects[0]?.sequence !== null) {
            this.studentSubjects.sort((a, b) =>
              a.sequence > b.sequence ? 1 : -1
            );
          }
          this.studentSubjectsLength = response.data.total;
        })
        .finally(() => {
          this.loading = true;
        });
    },

    getDepartmentSubjects() {
      ApiV2.get(
        `departments/${this.$route.params.odjeljenje_id}/departmentSubjects`,
        {
          params: {
            with: "subject",
            perPage: -1,
          },
        }
      ).then((response) => {
        this.optionalSubjects = response.data.data.filter(
          (item) => item.optional === 1
        );
      });
    },

    attachOptionalSubject() {
      ApiV2.post(
        `department_enrollment/${this.enrolledStudent.id}/departmentSubjects`,
        {
          data: this.optionalSubjectId,
          method: "attach",
        }
      )
        .then(() => {
          this.dialog = false;
          this.getStudentSubjects();
          serverBus.$emit("show-snackbar", true);
        })
        .catch(() => {
          serverBus.$emit("show-snackbar", false);
        });
    },

    sendDemand() {
      const body = {
        demandable_type: "DepartmentEnrollment",
        demandable_id: this.enrolledStudent.id,
        reason: this.demandReason,
        school_id: this.currentSchool.id,
        column_name: "locked_subjects",
      };

      ApiV2.post("demands", body)
        .then(() => {
          this.closeDemandDialog();
          serverBus.$emit("show-snackbar", true);
        })
        .catch(() => {
          serverBus.$emit("show-snackbar", false);
        });
    },

    lockDepartment() {
      ApiV2.post(
        `department_enrollment/${this.enrolledStudent.id}/lock_subjects`,
        {
          lock_subjects: 1,
        }
      )
        .then(() => {
          this.$store.dispatch("setEnrolledStudent", {
            departmentId: this.$route.params.odjeljenje_id,
            studentId: this.$route.params.ucenik_id,
          });

          this.lockDialog = false;
          serverBus.$emit("show-snackbar", true);
        })
        .catch(() => {
          serverBus.$emit("show-snackbar", false);
        });
    },

    detachOptionalSubject() {
      ApiV2.post(
          `department_enrollment/${this.enrolledStudent.id}/departmentSubjects`,
          {
            data: this.optionalSubjectId,
            method: "detach",
          }
      )
        .then(() => {
          this.deleteDialog = false;
          this.getStudentSubjects();
          serverBus.$emit("show-snackbar", true);
        })
        .catch(() => {
          serverBus.$emit("show-snackbar", false);
        });
    },
    detachOptionalSubjectSuperAdmin() {
      ApiV2.delete(`enrollment_subjects/${this.optionalSubjectId}/hard_delete`,
      )
          .then(() => {
            this.deleteDialog = false;
            this.getStudentSubjects();
            serverBus.$emit("show-snackbar", true);
          })
          .catch(() => {
            serverBus.$emit("show-snackbar", false);
          })
          .finally(() => {
            this.deleteDialogSuperAdmin = false;
            this.secondDeleteDialogSuperAdmin = false;
          });
    },


    updateSemesterGrade(item) {
      if (!this.enrolledStudent.locked_subjects) {
        serverBus.$emit(
          "show-message-dialog",
          "Potvrđivanje predmeta",
          "Morate potvrditi predmete da bi ste mogli zaključivati ocjene."
        );
        return;
      }

      Object.assign(this.form, item.pivot);

      if (item.pivot.final_grade_semester === undefined) {
        this.form.final_grade_semester = null;
      }
      if (item.pivot.final_grade_second_semester === undefined) {
        this.form.final_grade_second_semester = null;
      }
      if (item.pivot.final_grade === undefined) {
        this.form.final_grade = null;
      }

      if (this.$refs[`form_${item.id}`].validate()) {
        ApiV2.put(`enrollment_subject/${this.form.id}`, this.form)
          .then(() => {
            this.getStudentSubjects();
            serverBus.$emit("show-snackbar", true);
          })
          .catch(() => {
            serverBus.$emit("show-snackbar", false);
          });
      } else {
        serverBus.$emit(
          "show-snackbar",
          false,
          "Opisana ocjena ne smije sadržavati više od 150 znakova."
        );
      }
    },
  },
  async getDescriptiveGradeTemplates() {
    let {data} = await ApiV2.get(`descriptive_grade_templates`)
    console.log(data)
  }
};
</script>

<style lang="sass">
.optional-subject-list
    min-height: 16px
    .v-list-item__content, .v-list-item__action
        width: 100%
    .v-list-item__action
        margin-left: 0 !important

@media screen and (max-width: 375px)
    .send-demand-btn .v-btn__content
        max-width: 280px
</style>
